import React, {Fragment} from "react"
import { withStyles } from '@material-ui/core/styles'
import Grid from '@material-ui/core/Grid'
import {connect} from 'react-redux'
import moment from 'moment'

import {
  setSubject,
  setFromDate,
  setToDate,
  setDescription,
  setColor,
  setPrivate
} from '../../../actions/newAppointmentActions'

import NavBar from "../../NavBar"

import Subject from './Subject'
import Subjects from './Subjects'
import Dates from './Dates'
import Color from './Color'
import Private from './Private'
import Description from './Description'

const styles = theme => ({
  form: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  hr: {
    width: '100%',
    height: '1px',
    border: '0',
    backgroundColor: 'rgba(0,0,0,0.12)'
  }
})

class NewAppointment extends React.Component {
  handleSubjectChange = (e) => {
    this.props.dispatch(setSubject(e.target.value))
  }

  handleFromDateChange = (e) => {
    this.props.dispatch(setFromDate(moment(e.target.value + ' ' + this.props.newAppointment.fromDate.format('HH:mm'), 'YYYY-MM-DD hh:mm')))
  }

  handleFromTimeChange = (e) => {
      this.props.dispatch(setFromDate(moment(this.props.newAppointment.fromDate.format('YYYY-MM-DD') + ' ' + e.target.value, 'YYYY-MM-DD hh:mm')))
  }

  handleToDateChange = (e) => {
    this.props.dispatch(setToDate(moment(e.target.value + ' ' + this.props.newAppointment.toDate.format('HH:mm'), 'YYYY-MM-DD hh:mm')))
  }

  handleToTimeChange = (e) => {
    this.props.dispatch(setToDate(moment(this.props.newAppointment.toDate.format('YYYY-MM-DD') + ' ' + e.target.value, 'YYYY-MM-DD hh:mm')))
  }

  handleEditorChange = () => {
    if(window.tinyMCE.get('newDescription') != null)
      this.props.dispatch(setDescription(window.tinyMCE.get('newDescription').getContent()))
  }

  handleColorChange = (e) => {
    this.props.dispatch(setColor(e.target.value))
  }

  handlePrivateChange = (e) => {
    this.props.dispatch(setPrivate(e.target.checked))
  }

  render() {
    const { classes } = this.props

    return (
      <div>
        <NavBar/>
          <Grid container justify="center">
            <Grid item md={6}>
              <form className={classes.form}>
                <Subject
                  handleSubjectChange={this.handleSubjectChange}
                  newAppointment={this.props.newAppointment} />

                <hr className={classes.hr}/>

                <Dates
                  newAppointment={this.props.newAppointment}
                  handleFromDateChange={this.handleFromDateChange}
                  handleFromTimeChange={this.handleFromTimeChange}
                  handleToDateChange={this.handleToDateChange}
                  handleToTimeChange={this.handleToTimeChange} />

                <hr className={classes.hr}/>

                <Subjects />

                <hr className={classes.hr}/>

                <Color
                  handleColorChange={this.handleColorChange}
                  newAppointment={this.props.newAppointment} />

                <hr className={classes.hr}/>

                { !this.props.otherUser.loggedIn ? (
                  <Fragment>
                    <Private
                      handlePrivateChange={this.handlePrivateChange}
                      newAppointment={this.props.newAppointment}/>
                    <hr className={classes.hr}/>
                  </Fragment>
                ) : (
                  null
                )}

                <Description
                  newAppointment={this.props.newAppointment}
                  locale={this.props.i18n.locale}
                  dispatch={this.props.dispatch}
                  handleEditorChange={this.handleEditorChange} />
              </form>
            </Grid>
          </Grid>
      </div>
    )
  }
}

const mapDispatchToProps = (dispatch) => ({
  dispatch: dispatch
})

const mapStateToProps = (state) => ({
  newAppointment: state.newAppointment,
  i18n: state.i18n,
  otherUser: state.otherUser
})

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(NewAppointment))



// WEBPACK FOOTER //
// ./src/js/components/pages/newAppointment/NewAppointment.js